import { useTranslation } from "@opendash/i18n";
import { Form, Input } from "antd";
import React from "react";
import FormItemProps from "../../../types/FormItemProps";

export default (props: FormItemProps) => {
  const t = useTranslation();

  return (
    <Form.Item
      label={t("maintenance:items.create.form.internalNumber.label")}
      name="internalNumber"
      initialValue={props.editItem?.internalNumber}
    >
      <Input style={{ width: "100%" }} />
    </Form.Item>
  );
};
